export const TASK_DOMAINS = [
	"Clinical",
	"Administrative",
	"Cycle",
	"Medication",
	"Other",
] as const;

export type TaskDomain = (typeof TASK_DOMAINS)[number];

export const TASK_DOMAIN_COLORS: Record<TaskDomain, string> = {
	Clinical: "#5E60BF",
	Administrative: "#FFCD00",
	Cycle: "#E45BC2",
	Medication: "#FF8C00",
	Other: "#C1C1C1",
};

/** 10% tints per domain — used for completed-task "Completed" pill backgrounds. */
export const TASK_DOMAIN_TINT_COLORS: Record<TaskDomain, string> = {
	Clinical: "#eff0fb",
	Administrative: "#fffbed",
	Cycle: "#fff2fc",
	Medication: "#fff8f0",
	Other: "#f5f5f7",
};

export function resolveTaskDomain(
	value: string | undefined | null,
): TaskDomain {
	if (typeof value !== "string") return "Other";
	const trimmed = value.trim();
	if (!trimmed) return "Other";
	const match = (TASK_DOMAINS as readonly string[]).find(
		(domain) => domain.toLowerCase() === trimmed.toLowerCase(),
	);
	return (match as TaskDomain | undefined) ?? "Other";
}
